import React, { createContext, useContext, useMemo } from 'react';
import userData from '@PROJECT_ROOT/assets/responsive-frontend/js/services/userData';
import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';

/**
 * Zajednički podaci aplikacije dostupni svim komponentama na stranici.
 */
export const PageContext = createContext({ user: null });

/**
 * Dekodira korisnika iz tokena, ili iz localStoragea ako token nije proslijeđen.
 * @param {string} [userJWT] token iz parametara stranice ('0' znači da tokena nema)
 */
const decodeUser = (userJWT) => {
    if (userJWT && userJWT !== '0') {
        return userData.decodeToken(userJWT);
    }
    // Na serveru nema localStoragea.
    if (!windowManipulationService.isBrowserEnvironment()) return null;

    return userData.getDecodedUserDataFromLocalStorage();
};

/**
 * Postavlja se jednom na vrhu stranice i daje podatke svim komponentama ispod sebe.
 * @param {string} [userJWT] token iz parametara stranice
 */
export function PageContextProvider({ userJWT, children }) {
    // Ovisi samo o tokenu (string), pa se ponovno računa tek kad se token stvarno promijeni.
    const user = useMemo(() => decodeUser(userJWT), [userJWT]);

    // Vrijednost je memoizirana: novi objekt nastaje samo kad se neko polje promijeni,
    // inače bi se svi potrošači ponovno renderirali na svaki render providera.
    const value = useMemo(() => ({ user }), [user]);

    return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}

/** Vraća cijeli kontekst aplikacije. */
export const usePageContext = () => useContext(PageContext);

/** Vraća trenutnog korisnika iz konteksta, ili null ako nije prijavljen. */
export const useCurrentUser = () => usePageContext().user;
